"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAmortizationPDF = exports.findOneByCriteria = void 0;
const BanorteAmortization_1 = require("./BanorteAmortization");
const banorteRepository = __importStar(require("./BanorteRepository"));
function findOneByCriteria(criteria) {
    return banorteRepository.findOneByCriteria(criteria);
}
exports.findOneByCriteria = findOneByCriteria;
function generateAmortizationPDF(props) {
    const file = (0, BanorteAmortization_1.generate)({
        cat: +props.banorte.resultado?.cat,
        comisionDeApertura: +props.banorte.resultado?.comisiones,
        enganche: props.form.enganche,
        model_name: props.model.name,
        model_year: props.model.year,
        montoDelPrestamo: +props.banorte.resultado?.montoSolicitado,
        montoTotalAPagar: +props.banorte.resultado?.totalPagar,
        pagoMensual: Number(props.banorte.resultado?.pagoMensual) + Number(props.insurer?.primaTotal) / props.form.plazo,
        plazo: props.form.plazo,
        seguroDeAuto: props.insurer.aseguradora,
        seguroDeVida: +props.insurer.primaTotal,
        tasaDeInteres: +props.banorte.resultado?.tasa,
        registros: props.banorte.resultado?.registros
    });
    file.save();
}
exports.generateAmortizationPDF = generateAmortizationPDF;
